import React from "react";
import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  return (
    <div className="max-w-lg mx-auto px-4 py-24 text-center">
      <div className="w-20 h-20 rounded-3xl bg-brand-orange-soft text-brand-orange mx-auto mb-6 flex items-center justify-center">
        <XCircle size={40} />
      </div>
      <h1 data-testid="payment-cancel-heading" className="text-4xl font-semibold text-brand-blue">Checkout cancelled</h1>
      <p className="mt-3 text-brand-muted">No worries — no charge was made. You can revisit pricing whenever you're ready.</p>
      <div className="mt-8 flex flex-col gap-3">
        <Link to="/pricing" className="btn-primary">Back to pricing</Link>
        <Link to="/" className="btn-outline">Go home</Link>
      </div>
    </div>
  );
}
